import React from "react";
import styled from "styled-components";
import { About } from "../styles";
import clock from "../img/clock.svg";
import diaphragm from "../img/diaphragm.svg";
import html from "../img/html5.svg";
import css3 from "../img/css.svg";
import taill from "../img/tail.svg";
import js from "../img/javascript.svg";
import boot from "../img/boot.svg";
import git from "../img/git.svg";
import github from "../img/github.svg";
import heroku from "../img/heroku-ar21.svg";
import figma from "../img/figma-ar21.svg";
import mapbox from "../img/mapbox-ar21.svg";
import teamwork from "../img/teamwork.svg";
import stripe from "../img/stripe-ar21.svg";
import firebase from "../img/firebase.svg";
import { AnimateSharedLayout } from "framer-motion";
import { useScroll } from "./useScroll";
import { scrollReveal2 } from "../animation";

const FaqSection = () => {
  const [element, controls] = useScroll();
  return (
    <Faq
      variants={scrollReveal2}
      ref={element}
      animate={controls}
      initial="hidden"
    >
      <h2>
        <span>My Skills? </span>
      </h2>
      <AnimateSharedLayout>
        <div className="answer">
          <p style={{ margin: "40px" }}>
            <img style={{ paddingRight: "32px" }} alt="icon" src={html} />{" "}
            <img style={{ paddingRight: "32px" }} alt="icon" src={css3} />{" "}
            <img style={{ paddingRight: "33px" }} alt="icon" src={js} />{" "}
            <img style={{ paddingRight: "33px" }} alt="icon" src={clock} />{" "}
            <img style={{ paddingRight: "32px" }} alt="icon" src={teamwork} />{" "}
            <img style={{ paddingRight: "31px" }} alt="icon" src={github} />{" "}
            <img style={{ paddingRight: "31px" }} alt="icon" src={diaphragm} />{" "}
            <img style={{ paddingRight: "31px" }} alt="icon" src={taill} />{" "}
            <img style={{ paddingRight: "32px" }} alt="icon" src={firebase} />{" "}
            <img style={{ paddingRight: "31px" }} alt="Git" src={git} />{" "}
            <img style={{ paddingRight: "31px" }} alt="Git" src={heroku} />{" "}
            <img style={{ paddingRight: "31px" }} alt="Git" src={figma} />{" "}
            <img style={{ paddingRight: "31px" }} alt="Git" src={mapbox} />{" "}
            <img style={{ paddingRight: "35px" }} alt="Git" src={stripe} />{" "}
            <img
              style={{ paddingRight: "35px" }}
              alt="Terminal"
              src={boot}
            ></img>
          </p>
        </div>
      </AnimateSharedLayout>
    </Faq>
  );
};

const Faq = styled(About)`
  display: block;
  span {
    display: block;
  }
  h2 {
    padding-bottom: 2rem;
    font-weight: lighter;
  }
  .faq-line {
    background: #cccccc;
    height: 0.2rem;
    margin: 2rem 0rem;
    width: 100%;
  }
  .question {
    padding: 3rem 0rem;
    cursor: pointer;
  }
  .answer {
    padding: 2rem 0rem;
    p {
      padding: 1rem 0rem;
    }
  }
`;

export default FaqSection;
